import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { Drawer } from 'vaul'

import { KEYBOARD_CODE } from '@probatix/common/constants/keyboard'
import { BasicModalProps, ModalSingleType } from '@probatix/common/services/toolkit/modal/common/modalCommonService'
import useKeyPress from '@probatix/common/hooks/useKeyPress'
import { modalServiceActions, modalServiceSelectors } from '@probatix/common/services/toolkit/modal'

import { MODALS, ModalTypes } from '@probatix/myprobatix/modals'

import { RootState } from 'core/reducers'

interface ModalRootProps {
  modalStack?: ModalSingleType[]
}

export interface ModalBasicProps {
  onHideModal: () => {}
}

const ModalRoot: React.FC<ModalRootProps> = ({
  modalStack,
}) => {
  const dispatch = useDispatch()

  const closeModal = () => {
    dispatch(modalServiceActions.hide())
  }

  useKeyPress(KEYBOARD_CODE.ESCAPE, closeModal)

  if (!modalStack?.length) {
    return null
  }

  const renderModal = ({ modalType, modalProps = {} }: {
    modalProps: BasicModalProps,
    modalType: keyof ModalTypes,
  }) => {
    const SpecificModal = MODALS[modalType]

    return (
      <Drawer.Root key={MODALS[modalType]}>
        <SpecificModal
          {...modalProps}
          onHideModal={closeModal}
        />
      </Drawer.Root>
    )
  }

  return (
    <React.Fragment>
      {modalStack.map(renderModal)}
    </React.Fragment>
  )
}

const mapState = (state: RootState) => ({
  // @ts-ignore
  modalStack: modalServiceSelectors.getModalStack(state),
})

export default connect(mapState)(ModalRoot)
